import { IPendingPhotoVerificationRepository } from '../ports/outbound/IPendingPhotoVerificationRepository';
import { PendingPhotoVerificationResult } from '../domain/entities/PendingPhotoVerificationResult';
import { SortOrder } from "@/shared/application/domain/enums/SortOrder";
import {
  PhotoMatchDecision,
  PhotoMatchDecisionResponse,
  PhotoMatchDetailResponse,
} from '../ports/outbound/IPendingPhotoVerificationRepository';

export class FetchPendingPhotoVerificationUseCase {
  constructor(private repository: IPendingPhotoVerificationRepository) {}

  async execute(
    page: number,
    pageSize: number,
    columnName?: string,
    sortOrder?: SortOrder
  ): Promise<PendingPhotoVerificationResult> {
    return this.repository.fetchPendingPhotoVerificationRecords(
      page,
      pageSize,
      columnName,
      sortOrder
    );
  }

  async confirmPhotoMatch(i9FormId: string, eVerifyCase: string): Promise<void> {
    return this.repository.confirmPhotoMatch(i9FormId, eVerifyCase);
  }

  async reportPhotoMismatch(i9FormId: string, eVerifyCase: string, reason?: string): Promise<void> {
    return this.repository.reportPhotoMismatch(i9FormId, eVerifyCase, reason);
  }

  async getPhotoMatchDetails(caseId: string): Promise<PhotoMatchDetailResponse> {
    return this.repository.getPhotoMatchDetails(caseId);
  }

  async submitPhotoMatchDecision(
    caseId: string,
    decision: PhotoMatchDecision
  ): Promise<PhotoMatchDecisionResponse> {
    return this.repository.submitPhotoMatchDecision(caseId, decision);
  }
}
